module.exports = __webpack_public_path__ + "static/media/arrow-long-down.5ba98a4e.svg";